// extracted by mini-css-extract-plugin
export default {"test":"NotFoundPage_test__sSllW"};